// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"350":"48c23094","512":"dc567b1d"}[chunkId] + ".chunk.js";
};